import { useState } from "react";
import { fetcher } from "../../../../services/fetcher";
import { Stack } from "@mantine/core";
import {
  errorNotifications,
  successNotifications,
} from "../../../../utils/handleNotifications";
import nationalities from "../../../../data/nationality.json";
import countries from "../../../../data/countries.json";
import useOtherOptions from "../../../../common/hooks/useOtherOptions/useOtherOptions";
import MotherForm from "../../forms/MotherCoverForm/MotherCoverForm";
import useAdventureOptions from "../../../../common/hooks/useAdventureOptions/useAdventureOptions";
import { useNavigate } from "react-router-dom";
import PlanFormPageShell from "../../components/PlanFormPageShell/PlanFormPageShell";
// import classes from "./AddMotherCover.module.css";
import dayjs from "dayjs";

const AddMotherCovers = () => {
  const endpoint = "cover-api/mother-covers/";
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { options: adventureOptions, isLoading } = useAdventureOptions(
    "cover-api/adventures/"
  );

  const { options: partnersOptions, isLoading: loadingPartners } =
    useOtherOptions("cover-api/insurance-partners/");

  const addMotherCoverMutation = async (newCover) => {
    setIsSubmitting(true);
    try {
      await fetcher(endpoint, "POST", newCover, {
        "content-type": "multipart/form-data",
      });
      navigate(-1);
      successNotifications("Success! Mother cover added");
    } catch (error) {
      console.error(error);
      errorNotifications(error.response.data, error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (payload) => {
    const formData = new FormData();
    

    for (const key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        if (Array.isArray(payload[key])) {
          payload[key].forEach((id) => {
            formData.append(key, id);
          });
        } else {
          if (key === "start_date" || key === "end_date") {
            const formattedDate = dayjs(payload[key]).format("YYYY-MM-DD");
            formData.append(key, formattedDate);
          } else {
            formData.append(key, payload[key]);
          }
        }
      }
    }

    addMotherCoverMutation(formData);
  };

  // console.log(adventureOptions);

  return (
    <>
      <PlanFormPageShell title="+ Add Mother Plan">
        <Stack mt="xl">
        <MotherForm
          nationalities={nationalities}
          countries={countries}
          adventureOptions={isLoading ? [] : adventureOptions}
          partnersOptions={loadingPartners ? [] : partnersOptions}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </Stack>
      </PlanFormPageShell>
    </>
  );
};

export default AddMotherCovers;
